import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Home from "../pages/Home/Home";
import TermsOfService from "../pages/TermsOfService/TermsOfService";
import Contact from "../pages/Contact/Contact";
import BlogPage from "../pages/Blogs/BlogPage";
import BlogsList from "../pages/Blogs/BlogsList";
import News from "../pages/News";
import NewsPage from "../pages/News/NewsPage";
import QuranPdf from "../pages/QuranPdf/QuranPdf";
import SurahYaseen from "../pages/SurahYaseen/SurahYaseen";
import DeenBuddy from "../pages/deenbuddy/deenbuddy";
import NotFound from "../pages/NotFound/NotFound";
import {
    QURAN_PDF_CANONICAL_PATH,
    QURAN_PDF_REDIRECT_PATHS,
} from "./quranPdfRedirects";

// /privacy-policy and /data-deletion are static HTML (public/*.html),
// served via Firebase rewrites / src/setupProxy.js — not React routes.

const AppRoutes = () => (
    <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/news" element={<News />} />
        <Route path="/news/:slug" element={<NewsPage />} />

        <Route path="/blogs" element={<BlogsList />} />
        <Route path="/blogs/:slug" element={<BlogPage />} />

        <Route path={QURAN_PDF_CANONICAL_PATH} element={<QuranPdf />} />
        {QURAN_PDF_REDIRECT_PATHS.map((path) => (
            <Route
                key={path}
                path={path}
                element={<Navigate to={QURAN_PDF_CANONICAL_PATH} replace />}
            />
        ))}

        <Route path="/surah-yaseen" element={<SurahYaseen />} />
        <Route path="/deenbuddy" element={<DeenBuddy />} />

        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/contact" element={<Contact />} />

        <Route path="*" element={<NotFound />} />
    </Routes>
);

export default AppRoutes;
